export const INPUT_OPERATORS = ['contains', 'doesNotContain'];
export const SINGLE_SELECT_OPERATORS = ['is', 'isNot'];
